import { css } from '@inter-ikea-kompis/web-component';
/**
 * A utility to add styling for components used for navigation.
 *
 * Only to be used internally within Kompis: in main header, main footer, summary page and the content margins component.
 */
export default class StyleUtility {
    static getSpaceForHeader({ cssSelector, theme }) {
        const { breakpoint, spacing } = theme;
        return css `
			${cssSelector} {
				margin-top: calc(${80 / 16}rem + ${spacing.space125 / 16}rem);

				@media (min-width: ${breakpoint.large.width / 16}rem) {
					margin-top: calc(${90 / 16}rem + ${spacing.space125 / 16}rem);
				}

				@media (min-width: ${breakpoint.xlarge.width / 16}rem) {
					margin-top: calc(${90 / 16}rem + ${spacing.space250 / 16}rem);
				}
			}
		`;
    }
    static getLayoutParentStyling({ cssSelector, theme }) {
        const { breakpoint, spacing } = theme;
        return css `
			@media (min-width: ${breakpoint.xlarge.width / 16}rem) {
				${cssSelector} {
					display: grid;
					grid-template-columns: repeat(13, minmax(0, 1fr));
					column-gap: ${spacing.space125 / 16}rem;
				}
			}
		`;
    }
    static getLayoutChildStyling({ cssSelector, theme }) {
        const { breakpoint } = theme;
        return css `
			${cssSelector} {
				display: block;
			}

			@media (min-width: ${breakpoint.xlarge.width / 16}rem) {
				${cssSelector} {
					grid-column-start: 2;
					grid-column-end: -1;
				}
			}
		`;
    }
    static getHorizontalSpacing({ cssSelector, theme, direction }) {
        const { breakpoint, spacing } = theme;
        const margins = {
            small: spacing.space150,
            medium: spacing.space200,
            large: spacing.space250,
            xlarge: spacing.space300
        };
        /* XXL in Kompis SkapaTheme is 1920, while Skapas is 1600, so we hardcode it here */
        const xxLargeBreakPoint = 1600;
        return css `
			${cssSelector} {
				padding-left: ${margins.small / 16}rem;
				padding-right: ${margins.small / 16}rem;
			}

			@media (min-width: ${breakpoint.medium.width / 16}rem) {
				${cssSelector} {
					padding-left: ${margins.medium / 16}rem;
					padding-right: ${margins.medium / 16}rem;
				}
			}

			@media (min-width: ${breakpoint.large.width / 16}rem) {
				${cssSelector} {
					padding-left: ${margins.large / 16}rem;
					padding-right: ${margins.large / 16}rem;
				}
			}

			@media (min-width: ${breakpoint.xlarge.width / 16}rem) {
				${cssSelector} {
					padding-left: ${direction === 'rtl' ? margins.xlarge / 16 : spacing.space125 / 16}rem;
					padding-right: ${direction === 'rtl' ? spacing.space125 / 16 : margins.xlarge / 16}rem;
				}

				/** Chrome & Firefox */
				:host-context([dir='rtl']) ${cssSelector} {
					padding-left: ${margins.xlarge / 16}rem;
					padding-right: ${spacing.space125 / 16}rem;
				}
			}

			/** Centralize the component with auto margins. */
			@media (min-width: ${xxLargeBreakPoint / 16}rem) {
				${cssSelector} {
					margin-left: auto;
					margin-right: auto;
					max-width: ${1792 / 16}rem; /* 122rem, matches the max width of Ikea main page layout*/
					padding-left: ${direction === 'rtl' ? margins.xlarge / 16 : spacing.space125 / 16}rem;
					padding-right: ${direction === 'rtl' ? spacing.space125 / 16 : margins.xlarge / 16}rem;
				}

				/** Chrome & Firefox */
				:host-context([dir='rtl']) ${cssSelector} {
					padding-left: ${margins.xlarge / 16}rem;
					padding-right: ${spacing.space125 / 16}rem;
				}
			}
		`;
    }
}
//# sourceMappingURL=StyleUtility.js.map